import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
interface AccordionItemProps {
  title: string;
  children: React.ReactNode;
  isOpen?: boolean;
  previewImage?: string;
}
export function AccordionItem({
  title,
  children,
  isOpen: defaultOpen = false,
  previewImage
}: AccordionItemProps) {
  const [isOpen, setIsOpen] = useState(defaultOpen);
  return <div className="mb-4 bg-white rounded-2xl shadow-sm border border-emerald-50 overflow-hidden" data-id="element-185">
      {previewImage && <div className="relative h-36 w-full overflow-hidden" data-id="element-186">
          <img src={previewImage} alt="" aria-hidden="true" className="w-full h-full object-cover object-top" data-id="element-187" />
          <div className="absolute inset-0 bg-gradient-to-b from-transparent via-white/10 to-white" data-id="element-188" />
        </div>}
      <button onClick={() => setIsOpen(!isOpen)} className="w-full px-6 py-5 flex items-center justify-between bg-white hover:bg-emerald-50/40 transition-colors text-left" data-id="element-189">
        <span className="font-semibold text-gray-800 pr-4" data-id="element-190">{title}</span>
        <motion.div animate={{
        rotate: isOpen ? 180 : 0
      }} transition={{
        duration: 0.2
      }} className="flex-shrink-0 text-teal-600" data-id="element-191">
          <ChevronDown size={20} data-id="element-192" />
        </motion.div>
      </button>
      <AnimatePresence initial={false} data-id="element-193">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} data-id="element-194">
            <div className="px-6 pb-5 text-gray-600 text-sm leading-relaxed border-t border-emerald-50 pt-4" data-id="element-195">
              {children}
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}